import { Image } from '@packages/shared/src/ui/Image/Image';

export type SpaBeaconImageProps = {
  /* image src */
  src: string;
  name?: string;
};

/**
 * SpaBeaconImage component to render SPA beacon images
 * */
export const SpaBeaconImage = ({ src, name }: SpaBeaconImageProps) => (
  // NOTE if some sponsored cards will be hidden visually: convert to absolute positioned div with background-image, to allow for not loading the image when it is hidden, and not interrupt the parent layout flow; for now all sponsored cards are visible, so we can just use an image
  <Image
    aria-hidden
    src={src}
    width={1}
    height={1}
    alt={name ?? ''}
    className="absolute top-0 left-0 hidden size-[1px]"
    unoptimized
  />
);
